import { render, staticRenderFns } from "./workflow-enroller.vue?vue&type=template&id=01b02e44"
import script from "./workflow-enroller.vue?vue&type=script&lang=js"
export * from "./workflow-enroller.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports